import React from "react";

const Recommendations = () => {
	return <div>Recommendations</div>;
};

export default Recommendations;
